<template>
  <div class="sidebar-search-container portal-sidebar-search-container">
    <div class="column sidebar-items">
      <div class="filter-results-title">
        <q-icon size="24px" class="filter-icon">
          <img
            class="svg-icon"
            src="../../assets/icons/filter-list-solid.svg"
          />
        </q-icon>
        <span class="title bold-font"> Filter resultaten </span>
      </div>
      <div class="row results-info-row item-width" aria-live="polite">
        <p class="results-info-p">
          <span class="results-count">
            {{ resultsCount }}
          </span>
          <span class="text-results"> resultaten</span>
        </p>
      </div>

      <div class="row reset-btns justify-between">
        <span class="active-filters-count"
          >Actieve filters: {{ activeFiltersCount }}</span
        >

        <div class="reset-buttons">
          <button class="reset-button" v-on:click="resetSearch(false)">
            <span class="reset-clear">Reset</span>
          </button>
          <span class="slash"> / </span>

          <button class="reset-button" v-on:click="resetSearch(true)">
            <span class="reset-clear">Wis</span>
          </button>
        </div>
      </div>

      <q-list class="filters-list">
        <div role="list">
        <q-expansion-item
          dense
          dense-toggle
          expand-icon="chevron_right"
          id="v-step-0"
          role="listitem"
          v-model="difficultyExpanded"
        >
          <template #header>
            <div
              class="q-item__section column q-item__section--main justify-center"
            >
              <div
                role="button"
                :aria-expanded="difficultyExpanded.toString()"
                aria-controls="difficulty-content"
                class="q-item__label"
              >
                Moeilijkheid
              </div>
            </div>
          </template>
          <template #default>
            <div
              id="difficulty-content"
              :aria-hidden="(!difficultyExpanded).toString()"
            >
              <DifficultyCheckBox
                class="sidebar-margin item-width statuses-box white-bg-box"
              />
            </div>
          </template>
        </q-expansion-item>

        <q-expansion-item
          dense
          dense-toggle
          expand-icon="chevron_right"
          id="v-step-0"
          role="listitem"
          v-model="successExpanded"
        >
          <template #header>
            <div
              class="q-item__section column q-item__section--main justify-center"
            >
              <div
                role="button"
                :aria-expanded="successExpanded.toString()"
                aria-controls="success-content"
                class="q-item__label"
              >
                Slaagkans
              </div>
            </div>
          </template>
          <template #default>
            <div
              id="success-content"
              :aria-hidden="(!successExpanded).toString()"
            >
              <ChanceOfSuccessCheckbox
                class="sidebar-margin item-width statuses-box white-bg-box"
              />
            </div>
          </template>
        </q-expansion-item>

        <q-expansion-item
          dense
          dense-toggle
          expand-icon="chevron_right"
          id="v-step-0"
          role="listitem"
          v-model="durationExpanded"
        >
          <template #header>
            <div
              class="q-item__section column q-item__section--main justify-center"
            >
              <div
                role="button"
                :aria-expanded="durationExpanded.toString()"
                aria-controls="duration-content"
                class="q-item__label"
              >
                Tijdsduur aanvraag
              </div>
            </div>
          </template>
          <template #default>
            <div
              id="duration-content"
              :aria-hidden="(!durationExpanded).toString()"
            >
              <ApplicationTimeCheckbox
                class="sidebar-margin item-width statuses-box white-bg-box"
              />
            </div>
          </template>
        </q-expansion-item>

        <q-expansion-item
          dense
          dense-toggle
          expand-icon="chevron_right"
          id="v-step-0"
          role="listitem"
          v-model="statusExpanded"
        >
          <template #header>
            <div
              class="q-item__section column q-item__section--main justify-center"
            >
              <div
                role="button"
                :aria-expanded="statusExpanded.toString()"
                aria-controls="status-content"
                class="q-item__label"
              >
                Status
              </div>
            </div>
          </template>
          <template #default>
            <div
              id="status-content"
              :aria-hidden="(!statusExpanded).toString()"
            >
              <FilterCheckBox
                class="sidebar-margin item-width statuses-box white-bg-box"
              />
            </div>
          </template>
        </q-expansion-item>

        <q-expansion-item
          dense
          dense-toggle
          expand-icon="chevron_right"
          role="listitem"
          v-model="contributionExpanded"
        >
          <template #header>
            <div
              class="q-item__section column q-item__section--main justify-center"
            >
              <div
                role="button"
                :aria-expanded="contributionExpanded.toString()"
                aria-controls="contribution-content"
                class="q-item__label"
              >
                Bijdrage
              </div>
            </div>
          </template>
          <template #default>
            <div
              id="contribution-content"
              :aria-hidden="(!contributionExpanded).toString()"
            >
              <div class="sidebar-margin dateselect-box no-margin-left">
                <div class="row justify-end">
                  <AccessibleTooltip
                    text="Filter leegmaken"
                    position="left"
                  >
                    <template #trigger="{ tooltipId, visible }">
                      <q-btn
                        flat
                        round
                        dense
                        class="clear-filter-button"
                        @click="resetBudgets()"
                        aria-label="Filter leegmaken"
                        :aria-describedby="visible ? tooltipId : undefined"
                      >
                        <i
                          class="las la-2x la-times-circle clear-filter-icon"
                          aria-hidden="true"
                        ></i>
                      </q-btn>
                    </template>
                  </AccessibleTooltip>
                </div>

                <div class="row start">
                  <q-input
                    v-model.number="min"
                    type="number"
                    min="0"
                    label="Minimaal €"
                    class="budget-input"
                    bg-color="white"
                    borderless
                    dense
                  />
                </div>

                <div class="row start">
                  <q-input
                    borderless
                    v-model.number="max"
                    type="number"
                    min="0"
                    label="Maximaal €"
                    bg-color="white"
                    style="width: 100%"
                    dense
                  />
                </div>
              </div>
            </div>
          </template>
        </q-expansion-item>
        
        </div>
        <AdvancedFilters class="adv-filters-box" ref="advancedFiltersBox" />
      </q-list>

      <q-dialog v-model="showProfileNotSetWarning" class="profile-popup">
        <q-card>
          <q-card-section class="column">
            <span class="q-ml-sm bold-font popup-text-error">
              Er is geen profiel ingesteld!
            </span>
            <q-icon
              name="error"
              size="32px"
              color="indigo-10"
              class="info popup-icon error-icon q-mt-sm"
            ></q-icon>
          </q-card-section>

          <q-card-actions align="center" class="q-mb-xs">
            <router-link
              :to="{ name: 'UserProfile', params: { tab: 'newsletter' } }"
              style="margin-right: 10px; text-decoration: none"
            >
              <q-btn
                class="orange-btn-filled bold-font q-mr-md q-mb-sm btn-profile"
                label="Ga naar profiel"
                no-caps
                dense
                @click="disableShowProfileNotSetWarning()"
              />
            </router-link>
            <q-btn
              label="Ok"
              class="orange-btn bold-font q-mr-md q-mb-sm"
              style="width: 60px"
              dense
              @click="disableShowProfileNotSetWarning()"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { computed } from "vue";
import store from "../../store/index.js";
import FilterCheckBox from "../search-components/StatusesCheckBox.vue";
import AdvancedFilters from "../search-components/AdvancedFilters.vue";
import FiltersService from "../../services/filters.service";
import SchemeUtils from "../../utils/schemes";
import UserService from "../../services/userprofile.service";
import DifficultyCheckBox from "../portals-components/DifficultyCheckbox.vue";
import ChanceOfSuccessCheckbox from "../portals-components/ChanceOfSuccessCheckbox.vue";
import ApplicationTimeCheckbox from "../portals-components/ApplicationTimeCheckbox.vue";
import { useI18n } from "vue-i18n";
import AccessibleTooltip from "../global-components/AccessibleTooltip.vue";

export default {
  components: {
    FilterCheckBox,
    AdvancedFilters,
    DifficultyCheckBox,
    ChanceOfSuccessCheckbox,
    ApplicationTimeCheckbox,
    AccessibleTooltip,
  },
  setup() {
    const { locale } = useI18n();

    const difficultyExpanded = ref(false);
    const successExpanded = ref(false);
    const durationExpanded = ref(false);
    const statusExpanded = ref(false);
    const contributionExpanded = ref(false);
    const advancedFiltersBox = ref(null);

    const showProfileNotSetWarning = computed({
      get: () => store.state.user.showProfileNotSetWarning,
    });
    const schemeStatusGroup = computed({
      get: () =>
        store.state.advancedSearch.schemeStatusGroup &&
        store.state.advancedSearch.schemeStatusGroup.length > 0 &&
        (JSON.parse(sessionStorage.getItem("schemeStatusGroup")) == null ||
          (JSON.parse(sessionStorage.getItem("schemeStatusGroup")) &&
            store.state.advancedSearch.schemeStatusGroup.join() ===
              JSON.parse(sessionStorage.getItem("schemeStatusGroup")).join()))
          ? store.state.advancedSearch.schemeStatusGroup
          : JSON.parse(sessionStorage.getItem("schemeStatusGroup")),
    });
    const min = computed({
      get: () =>
        store.state.advancedSearch.minBudget != null
          ? store.state.advancedSearch.minBudget
          : Number(sessionStorage.getItem("minBudget")),
      set: async (value) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedSearch/updateMinBudget", value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });
    const max = computed({
      get: () =>
        store.state.advancedSearch.maxBudget != null
          ? store.state.advancedSearch.maxBudget
          : Number(sessionStorage.getItem("maxBudget")),
      set: async (value) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedSearch/updateMaxBudget", value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });
    const resultsCount = computed({
      get: () => store.state.advancedSearch.numberOfResults,
    });
    const isSearchPaused = computed({
      get: () => store.state.advancedSearch.applySavedSearchPause,
    });
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const activeFiltersCount = computed({
      get: () => store.state.advancedSearch.activeFiltersCount,
    });

    const resetSearch = async (isClear) => {
      store.commit("advancedSearch/updateIsResetSearch", true);
      store.commit("advancedSearch/resetSearchFilter", isClear);

      advancedFiltersBox.value.resetValues();

      if (isClear) {
        UserService.setApplyFilter(false);
        store.commit("user/setIsApplyingFilters", false);
      }

      if (!isClear) {
        store.commit("advancedSearch/updateIsApplyingFiltersReset", true);
      }
      store.commit("advancedSearch/updateIsResetSearch", false);
    };

    const resetBudgets = async () => {
      store.commit("advancedSearch/updateMinBudget", null);
      store.commit("advancedSearch/updateMaxBudget", null);
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
    };

    onMounted(async () => {
      await FiltersService.getDefaultFilters();
    });

    watch(schemeStatusGroup, async () => {
      if (!isSearchPaused.value) {
        await SchemeUtils.searchSchemes(locale);
      }
    });

    return {
      schemeStatusGroup,
      locale,
      isVind,
      isSearchPaused,
      showProfileNotSetWarning,
      activeFiltersCount,
      advancedFiltersBox,
      resultsCount,
      min,
      max,
      difficultyExpanded,
      successExpanded,
      durationExpanded,
      statusExpanded,
      contributionExpanded,
      resetBudgets,
      resetSearch,
    };
  },
};
</script>
